import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { AppRoute } from '@app/app-routes.enum';
import { isEnvFeatureEnabled } from '@app/core/env-feature/env-feature';
import { EnvType } from 'src/environments/common/environment-type.enum';

export function envFeatureGuardConstructor(envs: EnvType[]): CanActivateFn | CanMatchFn {
  return () => {
    const router: Router = inject(Router);

    if (!isEnvFeatureEnabled(envs)) {
      return router.createUrlTree([AppRoute.Base]);
    }

    return true;
  };
}
